import styled from 'styled-components';
import { HeightProps, WidthProps } from '.';

export default styled.img`
  border-radius: ${({ rounded }) => rounded && '1000vw'};
  ${HeightProps};
  ${WidthProps};
`;
